module.exports = __webpack_public_path__ + "img/praja.50d1fb27.svg";